module.exports = __webpack_public_path__ + "img/dave-menu-logo.7bcb36a1.svg";